import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateNewsRequest, NewsArticle, UpdateNewsRequest } from './news-profile.model';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpClient) {}

  getAllNews(params?: { [key: string]: any }): Observable<NewsArticle[]> {
    const httpParams = params ? new HttpParams({ fromObject: params }) : new HttpParams();

    return this.http.get<NewsArticle[]>('/v1/news/all', { params: httpParams });
  }

  getNews(id: number): Observable<NewsArticle> {
    return this.http.get<NewsArticle>(`/v1/news`, { params: { id: id.toString() } });
}

  createNews(news: CreateNewsRequest): Observable<NewsArticle> {
    return this.http.post<NewsArticle>('/v1/news', news);
  }

  updateNews(id: number, updatedArticle: UpdateNewsRequest): Observable<NewsArticle> {
    return this.http.put<NewsArticle>(`/v1/news?id=${id}`, updatedArticle);
  }

  deleteNews(id: number): Observable<void> {
    return this.http.delete<void>(`/v1/news/${id}`);
  }

  getNewsCount(params?: { [key: string]: any }): Observable<number> {
    const httpParams = params ? new HttpParams({ fromObject: params }) : new HttpParams();

    return this.http.get<number>('/v1/news/count', { params: httpParams });
  }
}
